/**
 * @Description: 给对应的路由元信息添加信息
 * @Author: kayvor
 * @Date: 2020-04-21 10:45:49
 * @LastEditTime: 2020-04-21 11:50:27
 * @LastEditors: kayvor
 */
import _ from 'lodash'

const initRoutesMeta = routes => {
    _.each(routes, route => {
        // 检查先
        if (route.path.indexOf('/') < 0 && route.path.indexOf('*') < 0) {
            throw new Error(route.path + 'path must begin with "/"')
        }
        route.meta = route.meta || {}
        if (_.isUndefined(route.meta.keepAlive)) {
            route.meta.keepAlive = true
        }
        route.meta.cacheName = route.componentName
    })
}

export {
    initRoutesMeta
}
